<template lang="pug">
  .edit-product-item-weight.border-bottom
    v-card(flat)
      v-row(no-gutters)
        v-col.py-1.shrink
          v-img.ma-2(:src="product.image ? product.image.file : require('@/assets/image_placeholder.png')" max-width="88" width="110px" height="88")
        v-col.py-3.pr-2
          v-row(no-gutters)
            v-col
              div.p1.basic800--text.mb-1(style="word-break: break-word;") {{ product.name }}
              show-more-text.product-list-description.mt-2.pr-2(:text="product.description" max=55 style="line-height: 1.2em; min-height:45px;")
            v-col.shrink(align="center")
              div(style="width: 70px")
                p.mb-1.label.basic600--text.text-uppercase {{ $t('weight_kg') }}:
                v-text-field.centered-input(
                  v-model.number="weight"
                  :class="{ 'weightChanged': (weight != product.weight && 0.1 <= weight && weight <= 60) || (focused && 0.1 <= weight && weight <= 60) }"
                  placeholder="0" background-color="basic200" height="40" outlined dense hide-details type="number" min="0.1" max="60" step="0.1" :rules="rules.weight"
                )
                .align-self-center.c1.danger500--text(v-if="0.1 > weight")| Min. 0.1KG
                .align-self-center.c1.danger500--text(v-if="weight > 60")| Max. 60KG
          v-row(no-gutters align="center")
            v-col
              div.c2.basic600--text {{ product.price | displayPrice }} 
                    //- v-layout
                    //-   div.mx-1.my-auto.font-weight-bold {{ product.weight || 0 }} kg
                    //-   v-icon(small) mdi-pencil
        v-col.shrink

    .modals
       y-dialog(v-model='openEditDialog', max-width='320' persistent)
          v-card
            v-card-title.title {{ $t('update_weight') }}
            v-card-text
              v-form(ref="form")
                v-text-field.mb-n4(v-model='weight' :label="$t('weight.label')" :placeholder="$t('weight.placeholder')" outlined dense type="number" suffix="kg" :rules="rules.weight")
            v-card-actions
              v-spacer
              v-btn(color='grey', text='', @click='openEditDialog = false')
                | {{ $t('cancel') }}
              v-btn(color='accent' depressed height=32 @click='updateWeight()')
                | {{ $t('update') }}

</template>

<script>
import { mapActions } from 'vuex'
import ShowMoreText from '@/components/ShowMoreText.vue'

export default {
  name: 'EditProductItemWeight',
  props: ['product','focused','edited'],
  components: { ShowMoreText },
  data: (v) => ({
    openEditDialog: false,
    weight: v.product.weight,
    rules: {
      weight: [
        v => !!v || 'This field is required',
        v => v >= 0.1 || 'Weight should not be below 0.1 KG',
        v => v <= 60 || 'Weight should not be above 60 KG',
      ]
    }
  }),
  mounted(){
      this.weight = this.edited.weight
  },
  watch: {
    weight (val) {
      this.$emit('editWeight', {id: this.product.id, weight: val==this.product.weight ? null : val})
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    updateWeight() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.axios.patch(`/products/${this.product.id}/`, { weight: this.weight })
        .then(resp => {
          this.product = resp.data
          this.openEditDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    }
  }
}
</script>

<style scoped>
.centered-input >>> input {
  text-align: center
}
.count-list-layout {
  position: absolute;
  right: 4px;
}
.product-list-title {
  color:#2E2E2E;
  size: 9px;
  font-weight: bold;
}
.product-list-description {
  color: #2E2E2E;
  font-size: 12px;
  white-space: pre-wrap;
}
.clickable {
  cursor: pointer;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.weightChanged{
  border: 1px solid var(--v-success500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
.product-description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical; 
  overflow: hidden;
}
.border-bottom{
    border-bottom: 1px solid var(--v-basic300);
    border-radius: 0 !important;
  }
</style>

<i18n>
{
  "en": {
    "weight": {
      "label": "Weight",
      "placeholder": "Min = 0.1 kg | Max = 60 kg"
    }
  },
  "id": {
    "weight": {
      "label": "Berat",
      "placeholder": "Minimal = 0.1 kg | Maksimal = 60 kg"
    }
  }
}
</i18n>